import { COMPONENT_CLASSES } from '#web-components/components/Form/constants';
import { spacing } from '#web-components/styles';

const columnsSelector = `.${COMPONENT_CLASSES.columns}`;

export const createColumnsStyles = () => ({
  [columnsSelector]: {
    '&.formio-component': {
      display: 'flex',
      flexWrap: 'wrap',
      marginLeft: `-${spacing * 2}px`,
      marginRight: `-${spacing * 2}px`,
      '& > [class^="col-"]': {
        paddingLeft: spacing * 2,
        paddingRight: spacing * 2,
      },
    },
  },
});
